/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import InsuranceClaim from './insurance-claim';
import InsuranceClaimDetail from './insurance-claim-detail';
import InsuranceClaimUpdate from './insurance-claim-update';
import InsuranceClaimDeleteDialog from './insurance-claim-delete-dialog';

const InsuranceClaimRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<InsuranceClaim />} />
    <Route path="new" element={<InsuranceClaimUpdate />} />
    <Route path=":id">
      <Route index element={<InsuranceClaimDetail />} />
      <Route path="edit" element={<InsuranceClaimUpdate />} />
      <Route path="delete" element={<InsuranceClaimDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default InsuranceClaimRoutes;
